// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createUserModalStyles } from "@pace/Overrides/Widgets/UserList/CreateUserModal";
import { userSetupSettingsStyles } from "@pace/Overrides/Widgets/UserSetup/UserSetupSettings";
import IconHelp from "@pace/XDL/Icons/IconHelp";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color } from "@pace/XDL/Utilities";
import { mergeWithCss } from "@pace/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

userSetupSettingsStyles.wrapper = {
    ...mergeWithCss(userSetupSettingsStyles.wrapper, {
        css: css`
            font-weight: ${fontConfig.weight.regular};
        `,
    }),
};
userSetupSettingsStyles.userRoleSelect = {
    ...mergeWithCss(userSetupSettingsStyles.userRoleSelect, {
        css: css`
            margin-bottom: 10px;
        `,
    }),
};

userSetupSettingsStyles.approverSelectTooltip = {
    iconProps: {
        size: 12,
        color: "common.ui14",
        css: css`
            &:hover {
                color: ${color("common.ui8")};
            }
        `,
    },
};

userSetupSettingsStyles.roleSelectHelpIcon = {
    src: IconHelp,
    size: 12,
    color: "common.ui14",
    css: css`
        margin-left: 8px;
        margin-right: 8px;
        margin-bottom: 1px;
        cursor: pointer;
        vertical-align: bottom;
        &:hover {
            color: ${color("common.ui8")};
        }
    `,
};
